import { Design } from "pages/design/design.type";
import { ETemplate } from "./design.type";
import { EFeatures, ESubscriptionPlan, ESubscriptionStatus } from "./features.type";

export interface IClient {
  readonly _id?: string;
  name?: string;
  code?: string;
  logo?: string;
  email?: string;
  phoneAppName?: string;
  shortDesc?: string;
  longDesc?: string;
  keywords?: string;
  features?: Features;
  design?: Design;
  menu?: [];
  description?: string;
  socials?: ISocials;
  settings?: ISettings;
  address?: IAddressClient;
  readonly template?: Template;
  readonly createdAt?: string;
  updatedAt?: Date;
  openingHours?: [OpeningHours];
  publishing?: {
    apple?: {
      bundleId: string;
      sku: string;
      appleId?: string;
      teamId?: string;
      version: string;
      buildNumber?: string;
      appName: string;
      subtitle: string;
      promotionalText?: string;
      description: string;
      keywords: string;
      primaryCategory: string;
      secondaryCategory?: string;
      supportEmail: string;
      supportUrl: string;
      marketingUrl?: string;
      privacyPolicyUrl: string;
      availableCountries: string[];
      primaryLanguage: string;
      additionalLanguages?: string[];
      ageRating?: string;
      copyright?: string;
      priceTier?: string;
    };
    google?: {
      packageName: string;
      versionName: string;
      versionCode?: number;
      appName: string;
      shortDescription: string;
      fullDescription: string;
      category: string;
      tags?: string[];
      developerName?: string;
      developerEmail: string;
      developerWebsite?: string;
      developerAddress?: string;
      privacyPolicyUrl: string;
      availableCountries: string[];
      defaultLanguage: string;
      additionalLanguages?: string[];
      targetAudienceAge: string[];
      contentRating?: string;
      containsAds: boolean;
      inAppPurchases?: boolean;
      priceMicros?: number;
    };
  };
}
export interface OpeningHours {
  day: "Monday" | "Tuesday" | "Wednesday" | "Thursday" | "Friday" | "Saturday" | "Sunday";
  slots: {
    open: string;
    close: string;
  }[];
}
export interface ICreateClient {
  name: string;
  email: string;
  activity: string;
  description: string;
  template: ETemplate;
}

export const SELECT_CUSTOMERS = "id,name,logo,statusClient,statusApp,createdAt,code";
export const SELECT_INFORMATION =
  "id,name,logo,description,keywords,design,socials,address,settings,openingHours";
export const SELECT_FEATURES = "features";
export const SELECT_DESIGN = "name,logo,design,menu";
export const SELECT_PUBLISHING = "publishing";

export enum StatusClient {
  PROSPECT = "Prospect",
  CLIENT = "Client",
}

export enum StatusApp {
  TEST = "Test",
  STAGING = "Staging",
  DEPLOYMENT = "Deployment",
}

export type DataFeatures = {
  enabled: boolean;
  key?: string;

  // Champs spécifiques pour hopelIA
  hasBeenActivated?: boolean; // Pour tracker la première activation

  // CRÉDITS ACHETÉS (permanent, séparé de l'abonnement)
  purchasedCredits?: number; // Crédits achetés, jamais perdus

  // ABONNEMENT (temporaire avec quota mensuel)
  subscriptionPlan?: ESubscriptionPlan; // BASIC ou PRO
  subscriptionStatus?: ESubscriptionStatus; // ACTIVE/PENDING/FAILED/CANCELLED
  subscriptionQuota?: number; // 10k pour BASIC, 50k pour PRO
  subscriptionStartDate?: Date; // Date de souscription initiale
  nextRenewalDate?: Date; // Prochaine date de renouvellement
  subscriptionUsage?: number; // Usage du cycle abonnement en cours
  stripeSubscriptionId?: string; // ID Stripe pour webhooks
};

export type Features = {
  [featureName in EFeatures]: DataFeatures;
};
export interface ISocials {
  webSite: string;
  twitter: string;
  facebook: string;
  instagram: string;
  linkedin: string;
}
export interface IStripeConnect {
  requirements: string[];
  accountId: string;
  enabled: boolean;
  chargesEnabled: boolean;
  detailsSubmitted: boolean;
  defaultCurrency: string;
  country: string;
}

export interface ISettings {
  currency?: ECurrency;
  statusApp?: EStatusApp;
  statusClient?: EStatusClient;
  statusEnv?: EStatusEnv;
  stripeConnect?: IStripeConnect;
  timezone?: string;
}
export interface IAddressClient {
  address: string;
  link: string;
}

export interface Template {
  category: ETemplate;
  images: [string];
}

export enum EStatusClient {
  PROSPECT = "Prospect",
  CLIENT = "Client",
}

export enum EStatusEnv {
  TEST = "Test",
  PRODUCTION = "Production",
}

export enum EStatusApp {
  BLOCKED = "blocked", // Blocked by superAdmin essentially
  DEACTIVATE = "deactivate",
  MAINTENANCE = "maintenance",
  DELETE = "delete",
  ACTIVATE = "activate",
  MAINTENANCE_ADMIN = "maintenance_admin",
  MAINTENANCE_SUPER_ADMIN = "maintenance_super_admin",
}

export enum ECurrency {
  EUR = "EUR",
  CAD = "CAD",
}

export type Platform = "ios" | "android";

export interface IVerifyBuildResponse {
  success: boolean;
  canBuild: boolean;
  missingRequirements?: string[];
  message?: string;
}

export interface ITriggerBuildResponse {
  success: boolean;
  message: string;
  buildId?: string;
  workflowUrl?: string;
}
